// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yW94I","value":"styles_value__16zHy","copy":"styles_copy__YNaDP","copied":"styles_copied__E5F18","highlighted":"styles_highlighted__kqjxQ"};